export default {
  SignOut: 'Sign out',
  NavHeaders: {
    Records: 'RECORDS',
    Metrics: 'METRICS',
    System: 'SYSTEM',
  },
  NavAccounts: {
    Care: {
      Title: 'Care',
    },
    Recruiter: {
      Title: 'Recruiter',
    },
    Ops: {
      Title: 'Ops',
    },
  },
  NavOptions: {
    MyDay: 'My Day',
    AllTasks: 'All Tasks',
    Playbooks: 'Playbooks',
    Skills: 'Skills',
    Cases: 'Cases',
    Automations: 'Automations',
    Metrics: {
      Title: 'Metrics',
      Options: {
        LeadFunnel: 'Lead funnel',
      },
    },
    Parameters: 'Parameters',
    Dashboard: {
      Title: 'Dashboard',
      Options: {
        YourDashboard: 'Your dashboard',
      },
    },
    Users: {
      Title: 'Users',
      Options: {
        New: 'Create new user',
        List: 'Users',
      },
    },
    Caregiver: {
      Title: 'Caregiver',
      Options: {
        New: 'Create new caregiver',
        List: 'Caregivers',
      },
    },
    ClientLead: {
      Title: 'Client lead',
      Options: {
        New: 'Create new client lead',
        List: 'Leads',
      },
    },
    Client: {
      Title: 'Client',
      Options: {
        New: 'Create new client',
        List: 'Clients',
      },
    },
    Schedule: {
      Title: 'Schedule',
      Options: {
        Client: 'Client schedule',
        Caregiver: 'Caregiver schedule',
      },
    },
    Career: {
      Title: 'Career',
      Options: {
        New: 'Create new job',
        List: 'Jobs',
      },
    },
  },
};
